import { useMemo } from "react";

import { FormV2FeatureFlags } from "../contexts/FormV2Context";

export const useInitFormV2FeatureFlags = (): FormV2FeatureFlags => {
  return useMemo(() => ({}), []);
};
